<template>
  <div id="map"></div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { Modal } from "bootstrap";

export default {
  name: "SectionHeader",
  data() {
    return {
      map: null,

      bounds: [
        [0, 0],
        [700, 1350],
      ],
      url: require("@/assets/images/MAP4.jpeg"),
      markers: {
        paddock: [
          {
            id: 46,
            latLng: [430, 655],
            title: "Paddock Club Suites",
            product: "paddock",
          },
          {
            id: 62,
            latLng: [410, 725],
            title: "Paddock Club East",
            product: "paddock",
          },
          {
            id: 47,
            latLng: [290, 550],
            title: "72 Club",
            product: "paddock",
          },
          {
            id: 68,
            latLng: [245, 195],
            title: "THE YACHTS @ MIA MARINA",
            product: "paddock",
          },
        ],
        suites: [
          {
            id: 59,
            latLng: [325, 350],
            title: "Turn 5 Suites",
            product: "suites",
          },
           {
            id: 57,
            latLng: [314, 205],
            title: "The Yacht Club Cabanas",
            product: "suites",
          },
          {
            id: 56,
            latLng: [408, 1250],
            title: "Beach House Cabanas",
            product: "suites",
          },
          {
            id: 50,
            latLng: [470, 300],
            title: "MIA Hospitality Village & Suites",
            product: "suites",
          },
          {
            id: 69,
            latLng: [389, 565],
            title: "Stadium Cabanas",
            product: "suites",
          },
          {
            id: 48,
            latLng: [213, 580],
            title: "McLaren Race House",
            product: "suites",
          },
          {
            id: 51,
            latLng: [557, 635],
            title: "Start / Finish Line Suites",
            product: "suites",
          },
          {
            latLng: [310, 750],
            title: "The villas at turn 1",
            product: "suites",
          },
          // {
          //   latLng: [270, 735],
          //   title: "the villas at turn 2",
          //   product: "suites",
          // },
          {
            id: 70,
            latLng: [275, 200],
            title: "THE YACHT CLUB SUITES",
            product: "suites",
          },
          {
            id: 52,
            latLng: [258, 470],
            title: "Crypto.com Terrace Suites",
            product: "suites",
          },
          {
            id: 64,
            latLng: [360, 955],
            title: "Trophy Suite",
            product: "suites",
          },
        ],
        cabanas: [      
          // {
          //   latLng: [388, 1250],
          //   title: "Beach house bungalows",
          //   product: "cabanas",
          // },
        ],
        club: [
          {
            id: 66,
            latLng: [160, 865],
            title: "Calle East",
            product: "club",
          },
          {
            id: 65,
            latLng: [285, 340],
            title: "Silver Arrow miami Club",
            product: "club",
          },
          {
            id: 60,
            latLng: [260, 320],
            title: "Ferrari Club",
            product: "club",
          },
          {
            id: 58,
            latLng: [375, 735],
            title: "Heineken Garden @ Turn 1",
            product: "club",
          },
          {
            id: 61,
            latLng: [393, 725],
            title: "Casa Tua Trackside Club",
            product: "club",
          },
          {
            id: 54,
            latLng: [220, 450],
            title: "The Race house club",
            product: "club",
          },
          {
            id: 55,
            latLng: [506, 750],
            title: "Start / Finish Line Club",
            product: "club",
          },
          {
            id: 53,
            latLng: [190, 800],
            title: "The Veranda",
            product: "club",
          },
          {
            id: 67,
            latLng: [230, 690],
            title: "Concours Club",
            product: "club",
          },
          {
            id: 63,
            latLng: [450, 310],
            title: "MIA HOSPITALITY VILLAGE CLUB",
            product: "club",
          },
        ],
        grandstands: [
          {
            latLng: [188, 950],
            title: "family grandstand",
            product: "grandstands",
          },
          // {
          //   latLng: [170, 370],
          //   title: "Fountain view grandstand",
          //   product: "grandstands",
          // },
          {
            latLng: [230, 350],
            title: "Luxury Row",
            product: "grandstands",
          },
          {
            latLng: [522, 120],
            title: "MIA HOSPITALITY VILLAGE",
            product: "grandstands",
          },
          {
            latLng: [428, 1250],
            title: "The beach house @ MIA",
            product: "grandstands",
          },
          {
            latLng: [529, 670],
            title: "Start / Finish Line Grandstand",
            product: "grandstands",
          },
          // {
          //   latLng: [470, 890],
          //   title: "North Campus",
          //   product: "grandstands",
          // },
          {
            latLng: [405, 910],
            title: "Turn 1 North Grandstand",
            product: "grandstands",
          },
          {
            latLng: [305, 870],
            title: "Turn 1 East Grandstand",
            product: "grandstands",
          },
          {
            latLng: [320, 1200],
            title: "South Beach Grandstand",
            product: "grandstands",
          },
          {
            latLng: [420, 1090],
            title: "North Beach Grandstand",
            product: "grandstands",
          },
          // {
          //   latLng: [310, 40],
          //   title: "MIA Marina Grandstand 6",
          //   product: "grandstands",
          // },
          {
            latLng: [266, 40],
            title: "Marina Grandstands",
            product: "grandstands",
          },
          // {
          //   latLng: [225, 40],
          //   title: "MIA Marina Grandstand 8",
          //   product: "grandstands",
          // },
          {
            latLng: [490, 310],
            title: "Autonation Grandstand @ Turn 18",
            product: "grandstands",
          },
          // {
          //   latLng: [405, 315],
          //   title: "F1 Fan zone",
          //   product: "grandstands",
          // },
        ],
      },
    };
  },
  computed: {
    mapChildren() {
      return this.$store.getters["purl/getPageChildren"](2);
    },
    allPagesIds() {
      return this.$store.getters["purl/getAllPages"].map((p) => p.id);
    },
  },
  methods: {
    markerClickHandler: function (item) {
      if (item.id) {
        Promise.all([
          this.$store.dispatch(`modal/setComponentName`, `modalProduct`),
          this.$store.dispatch(`modal/setProductId`, item.id),
        ]).finally(() =>
          new Modal(document.getElementById("mainModal")).show()
        );
      }
    },
    onTwoFingerDrag(e) {
      if (e.type === "touchstart" && e.touches.length === 1) {
        e.currentTarget.classList.add("swiping");
      } else {
        e.currentTarget.classList.remove("swiping");
      }
    },
    drawMap: function () {
      return new Promise((resolve, reject) => {
        const vi = this;
        const paddock = L.layerGroup();
        const suites = L.layerGroup();
        const cabanas = L.layerGroup();
        const club = L.layerGroup();
        const grandstands = L.layerGroup();

        const _layers = [];
        const controlLayers = {};
        //* add dynamic pins to map
        this.mapChildren.map((mapItem) => {
          switch (mapItem.id) {
            case 11:
              _layers.push(paddock);
              controlLayers[`<span id="paddock">Paddock Club</span>`] = paddock;
              break;
            case 12:
              _layers.push(suites);
              controlLayers[`<span id="suites">Suites</span>`] = suites;
              break;

            case 13:
              _layers.push(cabanas);
              controlLayers[`<span id="cabanas">Cabanas</span>`] = cabanas;
              break;

            case 14:
              _layers.push(club);
              controlLayers[`<span id="club">Club</span>`] = club;
              break;

            case 15:
              _layers.push(grandstands);
              controlLayers[
                `<span id="grandstands">Grandstands & Experiences</span>`
              ] = grandstands;

              break;

            default:
              break;
          }
        });

        vi.map = L.map("map", {
          crs: L.CRS.Simple,
          zoomDelta: 0.25,
          zoomSnap: 0,
          maxZoom: 1,
          // minZoom: 0,
          attributionControl: false,
          scrollWheelZoom: false,
          dragging: !L.Browser.mobile,
          tap: !L.Browser.mobile,
          layers: _layers,
        });

        L.imageOverlay(vi.url, vi.bounds).addTo(vi.map);
        vi.map.fitBounds(vi.bounds);
        vi.map.setMaxBounds(vi.bounds);

        document
          .getElementById("map")
          .addEventListener("touchstart", vi.onTwoFingerDrag);
        document
          .getElementById("map")
          .addEventListener("touchend", vi.onTwoFingerDrag);

        const markersArr = Object.keys(vi.markers);

        vi.allMarkers = {};

        markersArr.map((product) => {
          const arr = [];

          vi.markers[product].map(function (item) {
            //* Check if id in ON from the epitch
            if (item.id && !vi.idExist(item.id)) return;

            var markerX = L.marker(L.latLng(item.latLng))
              .setIcon(vi.getIcon(item.title, item.product, item.id))
              .on("click", () => vi.markerClickHandler(item));
            markerX.itemId = item.id;
            arr.push(markerX);
          });
          vi.allMarkers[product] = arr;
        });

        L.featureGroup(vi.allMarkers.paddock).addTo(paddock);
        L.featureGroup(vi.allMarkers.suites).addTo(suites);
        L.featureGroup(vi.allMarkers.cabanas).addTo(cabanas);
        L.featureGroup(vi.allMarkers.club).addTo(club);
        L.featureGroup(vi.allMarkers.grandstands).addTo(grandstands);

        L.control
          .layers(null, controlLayers, { collapsed: false })
          .addTo(vi.map);
        setTimeout(() => {
          resolve();
        }, 1000);
      });
    },
    getIcon: function (title, product, id) {
      const textCollor = {
        paddock: "#9A00F7",
        suites: "#008E97",
        cabanas: "#00D13C",
        club: "#FC4C02",
        grandstands: "#FF82D7",
      };
      return new L.DivIcon({
        className: "",
        html: `<span class="map_marker ${id ? "i" : ""}" style="color:${
          textCollor[product]
        }">${title}</span>`,
      });
    },
    idExist: function (id) {
      return this.allPagesIds.includes(id);
    },
  },
  mounted() {
    this.drawMap().then(() => {
      document
        .getElementById("paddock")
        ?.parentElement.setAttribute("id", "paddock");
      document
        .getElementById("suites")
        ?.parentElement.setAttribute("id", "suites");
      document
        .getElementById("cabanas")
        ?.parentElement.setAttribute("id", "cabanas");
      document.getElementById("club")?.parentElement.setAttribute("id", "club");
      document
        .getElementById("grandstands")
        ?.parentElement.setAttribute("id", "grandstands");
    });
  },
};
</script>

<style lang="scss">
#map {
  width: 100%;
  height: 800px;
  background: $color-secondary;
  @media (max-width: 900px) {
    // height: 700px;
  }
  &.swiping::after {
    content: "Use two fingers to move the map";
    color: #fff;
    font-size: 14px;
    font-weight: 300;
    justify-content: center;
    display: flex;
    align-items: center;
    padding: 15px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    font-family: Formula1-Display-Regular;
    // pointer-events: none!important;
  }
}
.leaflet-pane {
  @media (max-width: 900px) {
    margin-top: 40px;
  }
}
.leaflet-marker-icon {
  width: fit-content !important;
  height: 20px !important;
}
.map_marker {
  font-family: Formula1-Display-Regular;
  text-transform: uppercase;
  padding: 0.5em 1.2em;
  font-size: 0.6em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: max-content;
  text-align: center;
  line-height: 10px;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    background: white;
    z-index: -1;
    border-radius: 20px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
  }
  &.i:after {
    content: "";
    background-image: url("~images/info_w.svg");
    position: absolute;
    top: -8px;
    right: -5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 142%;
  }
}
.leaflet-control-layers-overlays {
  display: flex;
  column-gap: 15px;
  justify-content: center;
  @media (max-width: 900px) {
    flex-direction: column;
  }
}

.leaflet-top.leaflet-right {
  right: 50%;
  transform: translateX(50%);
  left: auto;
  background-image: linear-gradient(0deg, #ffffff 0%, #ffffff 100%);
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.17);
  border-radius: 30px;
  top: 10px;
  width: 526.5px;
  @media (max-width: 900px) {
    right: 0;
    left: 0;
    width: 100%;
    transform: none;
    border-radius: 0 !important;
    top: 0;
  }
}
.leaflet-top.leaflet-left {
  @media (max-width: 900px) {
    top: 180px;
  }
}
.leaflet-control-layers.leaflet-control-layers-expanded.leaflet-control {
  background: transparent;
  border: none;
  margin: 25px 21px 10px;
  width: 92%;
  @media (max-width: 900px) {
    margin: 14px 0 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &:before {
    content: "Click on a seating type for more information.";
    position: relative;
    top: -20px;
    font-family: TitilliumWeb-Regular;
    font-size: 12px;
    color: #000000;
    text-align: center;
    line-height: 19px;
    font-weight: 400;
    padding: 1em 0;
    width: 100%;
    text-align: center;
    display: block;
    border-bottom: 1px solid #00000012;
    margin-bottom: -8px;
    @media (max-width: 1200px) {
      padding: 0.5em 0;
    }
  }
}
.leaflet-control-layers-list {
  @media (max-width: 900px) {
    width: 100%;
  }
}
.leaflet-control-layers input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.leaflet-control-layers label {
  position: relative;
  cursor: pointer;
  @media (max-width: 900px) {
    height: 25px;
  }
}
.leaflet-control-layers label input[type="checkbox"] ~ span {
  padding-left: 25px;
  font-family: TitilliumWeb-Regular;
  font-size: 11.2px;
  color: #000000;
  line-height: 13.3px;
  font-weight: 400;
  @media (max-width: 900px) {
    list-height: 25.3px;
  }
}
.leaflet-control-layers label input[type="checkbox"] ~ span:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 19.5px;
  width: 19.5px;
  background: #ffffff;
  margin-right: 74px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.24);
  border-radius: 4.2px;
}

.leaflet-control-layers-overlays > label input[type="checkbox"] ~ span:after {
  content: "";
  position: absolute;
  display: none;
  left: 7px;
  top: 4px;
  width: 6px;
  height: 10px;
  border: solid black;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
  border-radius: 1px;
}
.leaflet-control-layers-overlays > label span#paddock:after {
  border-color: #9a00f7;
}
.leaflet-control-layers-overlays > label span#suites:after {
  border-color: #008e97;
}
.leaflet-control-layers-overlays > label span#cabanas:after {
  border-color: #00d13c;
}
.leaflet-control-layers-overlays > label span#club:after {
  border-color: #fc4c02;
}
.leaflet-control-layers-overlays > label span#grandstands:after {
  border-color: #ff82d7;
}
.leaflet-control-layers-overlays
  > label
  input[type="checkbox"]:checked
  ~ span:after {
  display: block;
}
</style>